import React from 'react';
import { DialogTitle, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { TaskIcon, TaskParentIcon } from '~/modules/common/components';
import { ADD_RESOURCE_ESTIMATE_DIALOG_TABS } from './constants';

const useStyles = makeStyles(theme => ({
  icon: {
    color: theme.palette.text.secondary,
    width: '1em',
    height: '100%',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  title: {
    whiteSpace: 'nowrap'
  },
  taskName: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  }
}));

const useTitleStyles = makeStyles(() => ({
  root: {
    '& h2': {
      display: 'flex',
      alignItems: 'center'
    }
  }
}));

const getTitleId = ({ isEditMode, activeTab }) => {
  if (isEditMode) return 'editResourceEstimateDialog.title';
  if (activeTab === ADD_RESOURCE_ESTIMATE_DIALOG_TABS.PLACEHOLDER)
    return 'addResourceEstimateDialog.titlePlaceholder';

  return 'addResourceEstimateDialog.title';
};

const AddResourceEstimateDialogHeader = ({
  task,
  isEditMode,
  dialogTitleId,
  activeTab
}) => {
  const { hasChildren, displayText } = task;
  const classes = useStyles();
  const titleClasses = useTitleStyles();

  const { formatMessage } = useIntl();

  const IconComponent = hasChildren ? TaskParentIcon : TaskIcon;

  return (
    <DialogTitle classes={titleClasses} id={dialogTitleId}>
      <span
        className={classes.title}
        data-qe-id="AddResourceEstimateDialogHeader"
      >
        {formatMessage({ id: getTitleId({ isEditMode, activeTab }) })}
      </span>
      <IconComponent className={classes.icon} />
      <span className={classes.taskName}>{displayText}</span>
    </DialogTitle>
  );
};

AddResourceEstimateDialogHeader.propTypes = {
  task: PropTypes.object,
  isEditMode: PropTypes.bool,
  dialogTitleId: PropTypes.string,
  activeTab: PropTypes.string
};

export default AddResourceEstimateDialogHeader;
